import React from "react";
import CustomEvent from "custom-event";
import { SuburbModel } from "../../models/SuburbModel";

import PostcodeField from "./PostcodeField";

interface State {
  current: string;
  selected: string;
  showError: boolean;
}

interface Props {
  fieldEl: any;
  formEl: any;
  emitEvents: boolean;
  simpleDisplay?: boolean;
  required?: boolean;
  onChange?: Function;
  onInputChange?: Function;
}

class PostcodeInline extends React.PureComponent<Props, State> {
  readonly state: State = {
    current: "",
    selected: "",
    showError: false
  };

  get isRequired(): boolean {
    const form = this.props.formEl;
    if (form) {
      return this.props.required || this.props.formEl.getAttribute("data-enforcepostcode") === 'true';
    } else {
      return false;
    }
  }

  componentDidMount() {
    const { fieldEl, formEl } = this.props;
    if (!fieldEl) {
      return console.log("No field to use.");
    }

    if (!formEl) {
      return console.log("No form to use.");
    }

    formEl.addEventListener("submit", e => {
      if (!this.isValid()) {
        this.setState({ showError: true });
        e.preventDefault();
      }
    });
  }

  componentDidUpdate() {
    if (!this.props.fieldEl) return;

    if (this.isValid) {
      this.props.fieldEl.value = this.state.selected;
    }
  }

  private isValid(): boolean {
    const { current, selected } = this.state;

    if (this.isRequired !== false) return current === selected && current.length > 0;
    else return current === selected;
  }

  private onSelect(suburb: SuburbModel, isRestored: boolean) {
    this.setState({ selected: suburb.postcode, current: suburb.postcode });

    if (this.props.emitEvents === true) {
      const evt: CustomEvent = new CustomEvent("locationSelected", {
        detail: { suburb: suburb, isRestored }
      });
      window.dispatchEvent(evt);
    }

    if (this.props.onChange) this.props.onChange(suburb);
  }

  private onPreSelect(suburb: SuburbModel) {
    if (this.props.emitEvents === true) {
      const evt: CustomEvent = new CustomEvent("locationPreSelected", {
        detail: { suburb: suburb }
      });
      window.dispatchEvent(evt);
    }
  }

  private onInputChange(value: string) {
    this.setState({ current: value });
    if (this.props.onInputChange) this.props.onInputChange(value);
  }

  render() {
    const { showError, current } = this.state;
    const simpleDisplay = this.props.simpleDisplay || false;

    return (
      <div>
        <PostcodeField
          doNotRestore={true}
          inputShowsSelected={true}
          saveOnPreSelect={true}
          onPreSelect={suburb => this.onPreSelect(suburb)}
          onSelected={(suburb, restored) => this.onSelect(suburb, restored)}
          onInputChange={value => this.onInputChange(value)}
          fieldClassName={`${!this.isValid() && showError ? "input-validation-error" : ""} pc__input--inline postBrochureDownload`}
          simpleDisplay={simpleDisplay}
        />

        {!this.isValid() && showError && (
          <span className="field-validation-error" style={{ display: "block", marginTop: "8px" }}>
            {current.length > 0 ? <span>Select your suburb</span> : <span>Postcode is required</span>}
          </span>
        )}
      </div>
    );
  }
}

export default PostcodeInline;
